<template>
    <div>
        <form @submit.prevent="submit">
            <template v-if="isIdoso">
                <div class="row">
                    <form-select
                        v-model="aspectoGeral.idoso.religiao_id"
                        :itens="$root.arrays.religiao_acolhimento"
                        label="Religião:"
                        grid="6"
                    />
                    <form-input
                        v-model="aspectoGeral.idoso.regiao"
                        label="Descreva a religião:"
                        grid="6"
                        v-show="mostrarDescReligiaoIdoso"
                    />
                    <form-input
                        v-model="aspectoGeral.idoso.habitos"
                        label="Hábitos:"
                        grid="6"
                    />
                    <form-input
                        v-model="aspectoGeral.idoso.hobbies"
                        label="Hobbies/Preferências de lazer:"
                        grid="6"
                    />
                    <form-input
                        v-model="aspectoGeral.idoso.habilidades"
                        label="Habilidades/Talento:"
                        grid="6"
                    />

                    <form-select
                        v-model="aspectoGeral.idoso.medos"
                        :itens="$root.arrays.pergunta"
                        label="Medos relevantes/traumas/dificuldades:"
                        grid="6"
                    />
                    <form-input
                        v-if="aspectoGeral.idoso.medos == 1"
                        v-model="aspectoGeral.idoso.medos_quais"
                        label="Qual?"
                        grid="6"
                    />
                    <form-select
                        v-model="aspectoGeral.idoso.planos"
                        :itens="$root.arrays.pergunta"
                        label="Planos ou desejos futuros?"
                        grid="6"
                    />
                    <form-input
                        v-if="aspectoGeral.idoso.planos == 1"
                        v-model="aspectoGeral.idoso.planos_quais"
                        label="Qual?"
                        grid="6"
                    />
                    <form-select
                        v-model="aspectoGeral.idoso.idoso_interesse_atividades"
                        :itens="$root.arrays.idoso_interesse_atividades"
                        label="Interesse em participar de atividades"
                        :multiple="true"
                    />
                    <form-input
                        v-model="aspectoGeral.idoso.idoso_interesse_outros"
                        label="Outras"
                    />
                    <form-select
                        v-model="aspectoGeral.idoso.restricao_saude"
                        :itens="$root.arrays.pergunta"
                        label="Há restrições de saúde, decisão judicial ou outro aspecto que impossibilite a saída desacompanhada ou a prática de atividade(s)?"
                    />
                    <form-textarea-editor
                        label="Rotina da pessoa idosa antes do acolhimento (sinalizar aspectos da rotina passíveis de serem mantidos)"
                        v-model="aspectoGeral.idoso.rotina"
                    />
                </div>
                <div class="row pt-4 px-0 d-flex justify-content-end">
                    <div class="col-auto px-2 text-right">
                        <button class="btn btn-success btn-submit" type="submit">
                            <i class="mdi mdi-content-save" />
                            {{ $t("Salvar") }}
                        </button>
                    </div>
                </div>
            </template>

            <template v-else>
                <div class="row">
                    <div class="col-12">

                        <template v-if="todasPessoas.length > 1">
                            <h3>Pessoas Vinculadas ao Acolhimento:</h3>

                            <b-table :items="todasPessoas" :fields="['nome', 'idade', 'parentesco']" small responsive>
                                <template #cell(nome)="row">
                                    <a href="#" @click.prevent="selecionarPessoa(row.item)">
                                        {{ row.item.nome }}
                                    </a>
                                </template>
                            </b-table>
                        </template>

                        <div
                            v-if="pessoaSelecionada"
                            :class="{ 'mt-4': todasPessoas.length > 1 }"
                        >

                            <h3> Aspectos Gerais de: {{ pessoaSelecionada.nome }}</h3>

                            <div class="row">
                                <form-select
                                    v-model="caractAspectoSelecionada.religiao_id"
                                    :itens="$root.arrays.religiao_acolhimento"
                                    label="Religião:"
                                    grid="6"
                                />
                                <form-input
                                    v-model="caractAspectoSelecionada.regiao"
                                    label="Descreva a religião:"
                                    v-show="mostrarDescReligiaoPessoa"
                                    grid="6"
                                />
                                <form-input
                                    v-model="caractAspectoSelecionada.habitos"
                                    label="Hábitos:"
                                    grid="6"
                                />
                                <form-input
                                    v-model="caractAspectoSelecionada.hobbies"
                                    label="Hobbies/Preferências de lazer:"
                                    grid="6"
                                />
                                <form-input
                                    v-model="caractAspectoSelecionada.habilidades"
                                    label="Habilidades/Talento:"
                                    grid="6"
                                />

                                <form-select
                                    v-model="caractAspectoSelecionada.medos"
                                    :itens="$root.arrays.pergunta"
                                    label="Medos relevantes/traumas/dificuldades:"
                                    grid="6"
                                />
                                <form-input
                                    v-if="caractAspectoSelecionada.medos == 1"
                                    v-model="caractAspectoSelecionada.medos_quais"
                                    label="Qual?"
                                    grid="6"
                                />
                                <form-select
                                    v-model="caractAspectoSelecionada.planos"
                                    :itens="$root.arrays.pergunta"
                                    label="Planos ou desejos futuros?"
                                    grid="6"
                                />
                                <form-input
                                    v-if="caractAspectoSelecionada.planos == 1"
                                    v-model="caractAspectoSelecionada.planos_quais"
                                    label="Qual?"
                                    grid="6"
                                />
                                <form-select
                                    v-model="caractAspectoSelecionada.idoso_interesse_atividades"
                                    :itens="$root.arrays.idoso_interesse_atividades"
                                    label="Interesse em participar de atividades"
                                    :multiple="true"
                                />
                                <form-input
                                    v-model="caractAspectoSelecionada.idoso_interesse_outros"
                                    label="Outras"
                                />
                                <form-select
                                    v-model="caractAspectoSelecionada.restricao_saude"
                                    :itens="$root.arrays.pergunta"
                                    label="Há restrições de saúde, decisão judicial ou outro aspecto que impossibilite a saída desacompanhada ou a prática de atividade(s)?"
                                />
                                <form-textarea-editor
                                    label="Rotina da pessoa idosa antes do acolhimento (sinalizar aspectos da rotina passíveis de serem mantidos)"
                                    v-model="caractAspectoSelecionada.rotina"
                                />
                            </div>
                            <div class="row pt-4 px-0 d-flex justify-content-end">
                                <div class="col-auto px-2 text-right">
                                    <button class="btn btn-success btn-submit" type="submit">
                                        <i class="mdi mdi-content-save" />
                                        {{ $t("Salvar") }}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </template>
        </form>
    </div>
</template>
<script>
export default {
    props: ["item"],
    data() {
        return { 
            aspectoGeral: {
                idoso: {
                    regiao: null,
                    habitos: null,
                    hobbies: null,
                    habilidades: null,
                    medos: null,
                    medos_quais: null,
                    planos: null,
                    planos_quais: null,
                    idoso_interesse_atividades: null,
                    idoso_interesse_outros: null,
                    restricao_saude: null,
                    rotina: null,
                    religiao_id: null,
                },
                pessoasVinculadas: []
            },
            caractAspectoSelecionada: null,
            pessoaReferencia: [],
            pessoaSelecionada: null,

        };
    },
    watch: {
        item: {
            immediate: true,
            handler(newVal) {
                if (newVal.aspectoGeral) {
                    this.aspectoGeral.idoso = newVal.aspectoGeral.idoso
                        ? this.preencherCamposAspecto(newVal.aspectoGeral.idoso)
                        : this.preencherCamposAspecto(null);

                    this.aspectoGeral.pessoasVinculadas = newVal.aspectoGeral.pessoasVinculadas || [];
                }else{
                    this.aspectoGeral.idoso = this.preencherCamposAspecto(null);
                    this.aspectoGeral.pessoasVinculadas = [];
                }

                this.pessoaReferencia = newVal.pessoaReferencia || [];
            }
        },
        todasPessoas: {
            immediate: true,
            handler(pessoas) {
                if (!this.isIdoso && pessoas.length === 1) {
                    this.selecionarPessoa(pessoas[0]);
                }
            }
        },
        'aspectoGeral.idoso.religiao_id'(novoValor) {
            if (novoValor != 8) {
                this.aspectoGeral.idoso.regiao = null;
            }
        },
        'caractAspectoSelecionada.religiao_id'(novoValor) {
            if (novoValor != 8) {
                this.caractAspectoSelecionada.regiao = null;
            }
        },
    },
    computed: {
        todasPessoas() {
            const pessoaPrincipal = {
                id: 'principal',
                nome: this.item.nome_acolhido,
                idade: this.calcularIdade(this.item.nascimento),
                parentesco: 'Acolhido(a)',
                tipo_cadastro: 'Principal',
            };

            const vinculados = this.pessoaReferencia.filter(
                p => p.tipo_cadastro === 'Familiar' || p.tipo_cadastro === 'Crianca'
            );

            return [pessoaPrincipal, ...vinculados];
        },
        isIdoso() {

            const hoje = moment();
            const nascimento = moment(this.item.nascimento, "YYYY-MM-DD");
            const idade = hoje.diff(nascimento, 'years');

            // Se existir público alvo, verifica se é 8, senão usa idade para decidir
            return this.item.solicitacao?.publico_alvo_id === 8 || idade >= 60;
        },
        mostrarDescReligiaoIdoso() {
            return this.aspectoGeral?.idoso?.religiao_id === 8;
        },
        mostrarDescReligiaoPessoa() {
            return this.caractAspectoSelecionada?.religiao_id === 8;
        },
    },
    mounted() {
        if (this.item.aspectoGeral) {

            this.aspectoGeral.idoso = this.item.aspectoGeral?.idoso
                ? this.preencherCamposAspecto(this.item.aspectoGeral.idoso)
                : this.preencherCamposAspecto(null);

            this.aspectoGeral.pessoasVinculadas = this.item.aspectoGeral?.pessoasVinculadas || [];

        }

        if (this.item.pessoaReferencia != null) {
            this.pessoaReferencia = this.item.pessoaReferencia;
        }
    },
    methods: {
        calcularIdade(dataNasc) {
            if (!dataNasc) return null;
            const hoje = new Date();
            const nasc = new Date(dataNasc);
            let idade = hoje.getFullYear() - nasc.getFullYear();
            const m = hoje.getMonth() - nasc.getMonth();
            if (m < 0 || (m === 0 && hoje.getDate() < nasc.getDate())) {
                idade--;
            }
            return idade;
        },
        submit() {

            if (this.pessoaSelecionada) {
                if (this.pessoaSelecionada.tipo_cadastro === 'Principal') {
                    this.aspectoGeral.idoso = { ...this.caractAspectoSelecionada };
                } else {
                    this.pessoaSelecionada.caracteristica_aspecto = { ...this.caractAspectoSelecionada };
                }
            }

            this.item.aspectoGeral = {
                idoso: this.aspectoGeral.idoso,
                pessoasVinculadas: this.pessoaReferencia
                    .filter(p => p.caracteristica_aspecto)
                    .map(p => ({
                    ...p.caracteristica_aspecto,
                    pessoa_referencia_id: p.id,
                    }))
            };

            this.$emit("submit");
        },
        verificarValueArray(value, array, valueIsArray = false) {
            if (valueIsArray && value) {
                var a = "";
                for (var i = 0; i < value.length; i++) {
                    const result = array.filter(item => item.id == value[i]);
                    a += result[0].value + (i < value.length - 1 ? "," : "");
                }
                return a;
            } else {
                const result = array.filter(item => item.id == value);
                return result[0] ? result[0].value : "";
            }
        },
        preencherCamposAspecto(obj) {
            const campos = [
                'regiao',
                'habitos',
                'hobbies',
                'habilidades',
                'medos',
                'medos_quais',
                'planos',
                'planos_quais',
                'idoso_interesse_atividades',
                'idoso_interesse_outros',
                'restricao_saude',
                'rotina',
                'religiao_id',
            ];

            if (!obj) obj = {};
            campos.forEach(campo => {
                if (obj[campo] === null || obj[campo] === undefined) {
                    obj[campo] = null;
                }
            });

            return obj;
        },
        selecionarPessoa(pessoa) {

            this.pessoaSelecionada = pessoa;

            if (pessoa.tipo_cadastro === 'Principal') {

                this.caractAspectoSelecionada = { ...this.aspectoGeral.idoso };

            }else{

                const dadosAspecto = this.item.aspectoGeral?.pessoasVinculadas?.find(
                    cs => cs.pessoa_referencia_id === pessoa.id
                );

                this.caractAspectoSelecionada = dadosAspecto ? { ...dadosAspecto } : {
                    pessoa_referencia_id: pessoa.id,
                    regiao: null,
                    habitos: null,
                    hobbies: null,
                    habilidades: null,
                    medos: null,
                    medos_quais: null,
                    planos: null,
                    planos_quais: null,
                    idoso_interesse_atividades: null,
                    idoso_interesse_outros: null,
                    restricao_saude: null,
                    rotina: null,
                    religiao_id: null,
                };

            }

        },
    }
};
</script>
